import AnalyticsService from '../../services/AnalyticsService';
import analyticsUseCase from './analyticsUseCase';

const analyticsFactory = analyticsUseCase({
  AnalyticsService: AnalyticsService(),
});

export default analyticsFactory;
